import { useState, useEffect } from "react";
import { usePaneStore } from "../state/store-context";
import { formatDuration } from "../lib/format-duration";

/**
 * E-004 — operator session timer for the standard Verification Station header.
 *
 * Elapsed time since the operator's session started (sessionStats.startTime,
 * set on first document load). Ticks once a second via a local interval that
 * is cleaned up on unmount. Reuses the shared formatDuration helper so the
 * standard and terminal-mode timers render identically. When the session
 * hasn't started yet (startTime === 0) the timer reads 0:00 — matching the
 * terminal stats bar's "elapsed = 0 until first load" convention.
 */
export function SessionTimer() {
  const startTime = usePaneStore((s) => s.sessionStats.startTime);
  // E-004 (completion) — operator preference gate ("Session timer visible").
  const visible = usePaneStore((s) => s.sessionTimerVisible);
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  const elapsed = startTime > 0 ? Date.now() - startTime : 0;

  return (
    <span className="vs-session-timer" data-testid="vs-session-timer" title="Operator session time">
      Session: {formatDuration(elapsed)}
    </span>
  );
}
